import { Flex, Box, Text } from '@chakra-ui/react';
import { CustomFormFieldComponent } from 'src/components/FormField';
import { FieldLabel } from 'src/components/Field';
import CustomFormFieldDateValidator from '../CustomFormFieldDateOfBirth';
import { useFormContext } from 'react-hook-form';
import SpecialtyKeywordTable from './SpecialtyKeywordTable';
import { OutlineCard } from '@morressier/alembic';
import InputArrayField from '../InputArrayField';

export const renderHeading = (config: any, dependentValue?: string) => {
  const {
    params: {
      labels,
      validations: { required },
      externalFieldDependency
    }
  } = config;

  return (
    externalFieldDependency?.value === dependentValue && (
      <FieldLabel
        label={labels.main}
        subText={labels?.subtitle ?? ''}
        isRequired={required}
      />
    )
  );
};

const ResearchFocusAndExpertise = ({
  configs,
  type
}: {
  configs: any;
  type?: string;
}) => {
  const { watch } = useFormContext();
  const reviewerInterest = watch('researchFocusAndExpertise.reviewerInterest');

  return (
    <Flex direction={'column'} gap={5}>
      {type && (
        <Text textStyle="headingGroup" id="ResearchFocusAndExpertise">
          {type} Research Interest
        </Text>
      )}
      <Flex direction={'column'} gap={3}>
        {configs.Specialty && configs.Keyword && (
          <OutlineCard width="100%" padding={4}>
            <Flex direction={'column'}>
              <SpecialtyKeywordTable
                configs={{
                  Specialty: configs.Specialty,
                  SubSpecialty: configs.SubSpecialty,
                  Keyword: configs.Keyword,
                  ScandinavianKeyword: configs.ScandinavianKeyword
                }}
              />
            </Flex>
          </OutlineCard>
        )}

        {configs?.ProfessionalInterests && (
          <OutlineCard width="100%" padding={4}>
            <InputArrayField
              tempFieldName="researchFocusAndExpertise.professionalInterestsTemp"
              fieldName="researchFocusAndExpertise.professionalInterests"
              validations={configs.ProfessionalInterests.params.validations}
              labels={configs.ProfessionalInterests.params.labels}
              placeholder="professional interest"
              isShowInfo
              errorLabelName="Professional Interests"
            />
          </OutlineCard>
        )}

        <Flex direction={'column'} gap={3}>
          <Flex id="ReviewerInterest" direction={'column'}>
            {configs?.ReviewerInterest && (
              <CustomFormFieldComponent config={configs?.ReviewerInterest} />
            )}
          </Flex>
          {configs.UnavailabilityPeriod &&
            renderHeading(configs.UnavailabilityPeriod, reviewerInterest)}
          <Flex gap={3} direction={{ base: 'column', md: 'row' }}>
            <Box width={'full'}>
              {configs?.UnavailabilityPeriodFrom && (
                <CustomFormFieldDateValidator
                  config={configs?.UnavailabilityPeriodFrom}
                  dependentFieldValue={reviewerInterest}
                  requiredWithFieldPath={
                    'researchFocusAndExpertise.unavailabilityPeriodTo'
                  }
                />
              )}
            </Box>
            <Box width={'full'}>
              {configs?.UnavailabilityPeriodTo &&
                configs?.UnavailabilityPeriodFrom && (
                  <CustomFormFieldDateValidator
                    config={configs?.UnavailabilityPeriodTo}
                    dependentFieldValue={reviewerInterest}
                    dependentFieldConfig={configs?.UnavailabilityPeriodFrom}
                    dependentFieldPath={
                      'researchFocusAndExpertise.unavailabilityPeriodFrom'
                    }
                    requiredWithFieldPath={
                      'researchFocusAndExpertise.unavailabilityPeriodFrom'
                    }
                  />
                )}
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ResearchFocusAndExpertise;
